export default [
	{
		path: '/team/reg',
		component: resolve => require(['@/components/team/reg.vue'], resolve),
		meta: {
			title: '团体注册',
	    	notNeedlogin: true
		}
	},
	{
		path: '/team/modify',
		component: resolve => require(['@/components/team/modify.vue'], resolve),
		meta: {
			title: '团体信息修改'
		}
	},
	{
		path: '/team/info',
		component: resolve => require(['@/components/team/info.vue'], resolve),
		meta: {
			title: '团体基本信息'
		}
	},
	{
		path: '/team/order',
		component: resolve => require(['@/components/team/order.vue'], resolve),
		meta: {
			title: '团体预约',
			notNeedlogin: true
		}
	},
	{
		path: '/team/list',
		component: resolve => require(['@/components/team/list.vue'], resolve),
		meta: {
			title: '团体预约-预约记录'
		}
	},
	{
		path: '/team/detail/:id',
		component: resolve => require(['@/components/team/detail.vue'], resolve),
		meta: {
			title: '团体预约-预约详情'
		}
	},
	{
		path: '/team/success',
		component: resolve => require(['@/components/team/regSuccess.vue'], resolve),
		meta: {
			title: '注册成功',
			notNeedlogin: true
		}
	}
]


// WEBPACK FOOTER //
// ./src/router/team/index.js